import { Phone, MessageCircle } from "lucide-react";
import { HOME } from "@/constants/testIds";

const PHONE = "+918310476246";
const WA_URL = "https://wa.me/918310476246";

const FloatingContact = () => {
    return (
        <div className="fixed bottom-5 right-5 z-[60] flex flex-col items-end gap-3">
            <a
                data-testid={HOME.floatingWhatsapp}
                href={WA_URL}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Chat with us on WhatsApp"
                className="group flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg hover:bg-[#1EAE53] hover:-translate-y-0.5 hover:shadow-xl transition-[transform,background-color,box-shadow] duration-200"
            >
                <MessageCircle className="h-6 w-6" strokeWidth={2.25} />
                <span className="sr-only">Chat on WhatsApp</span>
            </a>
            <a
                data-testid={HOME.floatingCall}
                href={`tel:${PHONE}`}
                aria-label={`Call us at ${PHONE}`}
                className="pulse-ring relative flex h-16 w-16 items-center justify-center rounded-full bg-[#1B3B2B] text-white shadow-xl hover:bg-[#2C5B42] hover:-translate-y-0.5 transition-[transform,background-color] duration-200"
            >
                <Phone className="h-7 w-7" strokeWidth={2.25} />
                <span className="sr-only">Call us at {PHONE}</span>
            </a>
        </div>
    );
};

export default FloatingContact;
